import isEmail from 'validator/es/lib/isEmail';
import isEmpty from 'validator/es/lib/isEmpty';
import isNumeric from 'validator/es/lib/isNumeric';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import IMask from 'imask';

export default new class Form {
    constructor() {
        this.maxFileSize = 52428800;
        this.sNoFiles = 'Приложить файл,&nbsp; jpg/png/pdf до 50 Мб'
        this.sHasFiles = 'Добавить еще файл'

        this.sFormClass = 'form';

        this.sFormStepClass = 'form-step';
        this.sFormStepBtnNextClass = 'form-step-next';
        this.sFormStepBtnBackClass = 'form-step-back';
        this.sFormStepBtnMoreClass = 'form-step-more';

        this.sFormFeedbackClass = '_form-feedback';
        this.sFormFeedbackReviewClass = '_form_feedback-review';
        this.sFormFeedbackQuestionClass = '_form_feedback-question';
        this.sFormSubscribeNewsClass = '_form-subscribe-news';
        this.sFormKpClass = '_form-kp';

        this.sFormMsgErrorClass = '_form-error-msg';
        this.sFormMsgErrorLgClass = '_form-error-msg-lg';
        this.sFormInputErrorTpl = '<div class="_form-error-msg"></div>';
        this.msg = {
            'empty': 'Обязательно для заполнения',
            'emptyCheckbox': 'Обязательно для заполнения',
            'incorect': 'Поле заполнено некорректно',
            'incorectName': 'Поле заполнено некорректно, не менее 2х символов',
        };

        this.sPhoneInputClass = '[name="phone"]';

        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.initPhoneMask();

            let _this = this;
            document.addEventListener('submit', (obEvent) => {

                //форма "Обратная связь"
                if(obEvent.target.closest(`.${this.sFormFeedbackClass}`)) {
                    obEvent.preventDefault();
                    this.feedbackSubmit(obEvent);
                }

                //форма "Обратная связь" отзыв
                if(obEvent.target.closest(`.${this.sFormFeedbackReviewClass}`)) {
                    obEvent.preventDefault();
                    this.feedbackReviewSubmit(obEvent);
                }
                //форма "Обратная связь" вопрос
                if(obEvent.target.closest(`.${this.sFormFeedbackQuestionClass}`)) {
                    obEvent.preventDefault();
                    this.feedbackQuestionSubmit(obEvent);
                }

                //форма "Подписывайтесь на новости компании"
                if(obEvent.target.closest(`.${this.sFormSubscribeNewsClass}`)) {
                    obEvent.preventDefault();
                    this.subscribeNewsSubmit(obEvent);
                }

                //форма "Отправьте предложение о закупке продукции"
                if(obEvent.target.closest(`.${this.sFormKpClass}`)) {
                    obEvent.preventDefault();
                    this.kpSubmit(obEvent);
                }
            })

            //форма с шагами,переключение шагов
            document.querySelectorAll(`.${this.sFormStepBtnNextClass}`).forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    let currentStep = parseInt(btn.closest(`.${this.sFormStepClass}`).getAttribute('data-step'))
                    let nextStepBlock = document.querySelector(`.${this.sFormStepClass}[data-step="${currentStep + 1}"]`)

                    if(nextStepBlock) {
                        if(this.validate(e, document.querySelector(`.${this.sFormStepClass}[data-step="${currentStep}"]`))) {
                            document.querySelectorAll(`.${this.sFormStepClass}`).forEach((stepBlock) => {
                                stepBlock.classList.remove('active')
                                stepBlock.classList.remove('activeXR')
                                stepBlock.classList.remove('activeXL')
                            });

                            nextStepBlock.classList.add('active')
                            nextStepBlock.classList.add('activeXR')
                        }
                    }
                });
            });
            document.querySelectorAll(`.${this.sFormStepBtnMoreClass}`).forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    let currentStep = 0
                    let nextStepBlock = document.querySelector(`.${this.sFormStepClass}[data-step="${currentStep + 1}"]`)

                    if(nextStepBlock) {
                        document.querySelectorAll(`.${this.sFormStepClass}`).forEach((stepBlock) => {
                            stepBlock.classList.remove('active')
                            stepBlock.classList.remove('activeXR')
                            stepBlock.classList.remove('activeXL')
                        });

                        nextStepBlock.classList.add('active')
                        nextStepBlock.classList.add('activeXR')
                    }
                });
            });
            document.querySelectorAll(`.${this.sFormStepBtnBackClass}`).forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    let currentStep = parseInt(btn.closest(`.${this.sFormStepClass}`).getAttribute('data-step'))
                    let nextStepBlock = document.querySelector(`.${this.sFormStepClass}[data-step="${currentStep - 1}"]`)
                    if(nextStepBlock) {
                        document.querySelectorAll(`.${this.sFormStepClass}`).forEach((stepBlock) => {
                            stepBlock.classList.remove('active')
                            stepBlock.classList.remove('activeXR')
                            stepBlock.classList.remove('activeXL')
                        });

                        nextStepBlock.classList.add('active')
                        nextStepBlock.classList.add('activeXL')
                    }
                });
            });
            //файл
            document.querySelectorAll('[type=file]').forEach((inputFile, index) => {
                let fileList = [];
                const filePlaceholder = inputFile.closest('.form-group').querySelector('.file-placeholder');
                const filePlaceholderWrap = filePlaceholder.closest('label').parentElement

                inputFile.addEventListener('change', (e) => {

                    if (inputFile.hasAttribute('multiple')) {
                        const newFiles = Array.from(inputFile.files).filter(file => {
                            return this.isValidFile(file) && !fileList.find(oldfile => file.name == oldfile.name);
                        });

                        newFiles.forEach((file) => {
                            filePlaceholder.innerHTML = this.sHasFiles;
                            filePlaceholderWrap.insertAdjacentHTML('beforebegin', `
                                <div class="relative file-item">
                                    <label class="flex w-full h-[54px] py-4 px-5 text-size16 tracking-base-1 text-dark rounded-[16px] bg-[#F9F6F1] border-[2px] border-transparent cursor-pointer">
                                        <div class="file-name text-size16 tracking-base-1 text-dark w-full max-w-[calc(100%-35px)] mr-1 overflow-hidden md:whitespace-nowrap">${file.name}</div>
                                    </label>
                                    <svg class="file-reset cursor-pointer absolute right-5 top-[15px] z-10"  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2432 4.34314L15.6575 5.75735L5.75796 15.6568L4.34375 14.2426L14.2432 4.34314Z" fill="#8F9094"/><path d="M15.6575 14.2426L14.2432 15.6568L4.34375 5.75735L5.75796 4.34314L15.6575 14.2426Z" fill="#8F9094"/></svg>
                                </div>
                            `);
                            const fileLabel = filePlaceholderWrap.previousElementSibling;
                            fileLabel.querySelector('.file-reset').addEventListener('click', () => {
                                fileList = fileList.filter(_file => file !== _file);
                                this.replaceInputFiles(inputFile, fileList);
                                setTimeout(() => {
                                    fileLabel.remove();
                                    if (!fileList.length) {
                                        filePlaceholder.innerHTML = this.sNoFiles;
                                    }
                                }, 0);
                            })
                        })

                        fileList.push(...newFiles);
                        this.replaceInputFiles(inputFile, fileList);

                    } else {
                        if (this.isValidFile(inputFile.files[0])) {
                            inputFile.closest('.form-group').querySelector('.file-name').textContent = inputFile.files[0].name
                            inputFile.closest('.form-group').querySelector('.file-name').style.display = 'block';
                            inputFile.closest('.form-group').querySelector('.file-reset').style.display = 'block';
                            inputFile.closest('.form-group').querySelector('.file-placeholder').style.display = 'none';
                            inputFile.closest('.form-group').querySelector('.file-plus').style.display = 'none';
                        } else {
                            inputFile.value = null;
                        }
                    }
                });
            });
            document.querySelectorAll('.file-reset').forEach((inputFileBtnReset) => {
                inputFileBtnReset.addEventListener('click', (e) => {
                    inputFileBtnReset.closest('.form-group').querySelector('[type=file]').value = null

                    inputFileBtnReset.closest('.form-group').querySelector('.file-name').style.display = 'none';
                    inputFileBtnReset.closest('.form-group').querySelector('.file-reset').style.display = 'none';
                    inputFileBtnReset.closest('.form-group').querySelector('.file-placeholder').style.display = 'block';
                    inputFileBtnReset.closest('.form-group').querySelector('.file-plus').style.display = 'block';
                });
            });
        });
    }

    initPhoneMask() {
        document.querySelectorAll(`${this.sPhoneInputClass}`).forEach((el) => {
            let mask = IMask(
                el,
                { mask: '+{7} ({900}) 0000000', /*lazy: false, placeholderChar: 'X'*/}
            );
            el.addEventListener('focus', () => {
                el.value = el.value || '+7 (9';
                mask.updateValue();
            })
        });
    }

    feedbackSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    feedbackReviewSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    feedbackQuestionSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    subscribeNewsSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    kpSubmit(obEvent) {
        obEvent.preventDefault();
        this.magicFormSubmit(obEvent);
    }

    //формы обратной связи
    magicFormSubmit(obEvent) {
        if(this.validate(obEvent)) {
            if(obEvent.target.classList.contains('_form-subscribe-news')) {
                document.querySelector('._form-subscribe-news button').style.opacity=0.7;
                document.querySelector('._form-subscribe-news button').style['pointer-events'] = 'none';
            }
            /*const _this = this;
            const form = obEvent.target;
            const submitBtn = form.querySelector('[type="submit"]');
            submitBtn.classList.add('_preloader');

            let components = 'genericForm';

            if(form.getAttribute('data-components') && form.getAttribute('data-components') != '') {
                components = form.getAttribute('data-components');
            }

            request.sendForm(form, components+'::onFormSubmit', {
                success: function(obData) {
                    submitBtn.classList.remove('_preloader');
                    if(form.classList.contains(_this.sFormSubcribeClass)) {
                        //Popup.popupMenuOpen('subcribe_success');
                        _this.showFormMsg('Вы успешно подписаны на новости!', form);

                        setTimeout(() => {
                            _this.deleteFormMsg(form);
                        }, 2500);
                    }
                    else {
                        Popup.popupMenuOpen('success');
                        //_this.showFormMsg('Отправлено!', form);
                        setTimeout(() => {
                            //_this.deleteFormMsg(form);
                            Popup.popupMenuClose()
                        }, 2500);
                    }

                    _this.resetForm(form);
                },
                error: _this.onError
            });*/
        }
        else {
            if(obEvent.target.classList.contains('_form-kp')) {
                let currentStep = parseInt(obEvent.target.querySelector('._form-error-msg').closest('.form-step').getAttribute('data-step'));
                let nextStepBlock = document.querySelector(`.${this.sFormStepClass}[data-step="${currentStep}"]`)
                if(nextStepBlock && document.querySelector(`.${this.sFormStepClass}.active`).getAttribute('data-step') != currentStep) {
                    document.querySelectorAll(`.${this.sFormStepClass}`).forEach((stepBlock) => {
                        stepBlock.classList.remove('active')
                        stepBlock.classList.remove('activeXR')
                        stepBlock.classList.remove('activeXL')
                    });

                    nextStepBlock.classList.add('active')
                    nextStepBlock.classList.add('activeXL')
                }
            }
        }
    }

    onError(...args) {
        console.log(...args);
    }

    //валидация полей форма
    validate(obEvent, parent = null) {
        let _this = this;
        let isValide = true;

        if(!parent) {
            parent = obEvent.target.closest(this.sFormClass)
        }

        parent.querySelectorAll('[data-required="true"]').forEach(element => {
            let value = element.value;

            if(element.getAttribute('name') == "data" && value[0] == "+") {
                value = value.substring(1)
            }
            if(isEmpty(value)) {
                //проверка на пустоту
                _this.showInputMsg(_this.msg['empty'], element);
                isValide = false;
            }
            else if(element.getAttribute('name') == "name" && value.length < 2) {
                //валидация имени
                _this.showInputMsg(_this.msg['incorectName'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "comment" && value.length < 2) {
                //валидация имени
                _this.showInputMsg(_this.msg['incorectName'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "data" && (!isEmail(value) && !(value.replace(/[^0-9]/g).length == 11 && isNumeric(value)))) {
                //валидация почты и номера телефона
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;

            }
            else if(element.getAttribute('name') == "email" && !isEmail(value)) {
                //валидация почты
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('name') == "phone" && !isMobilePhone('+' + value.replace(/[^0-9]/g, ''), ['ru-RU'])) {
                //валидация номера телефона
                _this.showInputMsg(_this.msg['incorect'], element)
                isValide = false;
            }
            else if(element.getAttribute('type') == "checkbox" && !element.checked) {
                //валидация checkbox
                _this.showInputMsg(_this.msg['emptyCheckbox'], element)
                isValide = false;
            }
            else {
                _this.deleteInputMsg(element)
            }
        });

        return isValide;
    }
    //валидация полей формы на пустоту
    validateEmpty(obEvent) {
        let _this = this;
        let isValide = true;

        obEvent.target.closest(this.sFormClass).querySelectorAll('[data-required="true"]').forEach(element => {
            let value = element.value;

            if(isEmpty(value)) {
                //проверка на пустоту
                isValide = false;
            }
            else if(element.getAttribute('type') == "checkbox" && !element.checked) {
                //валидация checkbox
                isValide = false;
            }
        });

        return isValide;
    }

    //отображение ошибки/сообщения для инпута
    showInputMsg(message, input) {
        let div = input.closest('div');

        input.classList.add('error')

        if(!div.querySelector(`.${this.sFormMsgErrorClass}`)) {
            let sFormInputErrorTpl = document.createElement("div");
            sFormInputErrorTpl.className = "_form-error-msg";
            div.appendChild(sFormInputErrorTpl)
        }

        div.querySelector(`.${this.sFormMsgErrorClass}`).textContent = message
    }
    //удаление ошибок
    deleteInputMsg(input) {
        input.classList.remove('error')
        if(input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`)) {
            input.closest('div').querySelector(`.${this.sFormMsgErrorClass}`).remove()
        }
    }
    //отображение ошибки/сообщения для формы после кнопки
    showFormMsg(message, form) {
        if(form.querySelector(`.${this.sFormMsgErrorLgClass}`)) {
            form.querySelectorAll(`.${this.sFormMsgErrorLgClass}`).forEach((msg) => {
                msg.textContent = message
            })
        }
    }
    //удаление ошибки/сообщения для формы после кнопки
    deleteFormMsg(form) {
        if(form.querySelector(`.${this.sFormMsgErrorLgClass}`)) {
            form.querySelectorAll(`.${this.sFormMsgErrorLgClass}`).forEach((msg) => {
                msg.textContent = ''
            })
        }
    }
    //очищенеи формы
    resetForm(form) {
        form.reset();
        form.querySelector('.button').classList.add('disable');
        form.querySelectorAll('.select').forEach((select) => {
            if (select.querySelector('input:checked')) {
                select.querySelectorAll('input:checked').forEach((item) => {
                    item.checked = false;
                });
            }
            const currentInput = select.querySelector('.select__input');
            const currentText = select.querySelector('.select__current');

            currentText.textContent = currentText.getAttribute('data-placeholder')
            currentText.removeAttribute('style')
            select.classList.remove('is-selected');
            currentInput.setAttribute("value", "")
        })
    }

    replaceInputFiles(input, files) {
        const dt = new DataTransfer();
        files.forEach(file => dt.items.add(file))
        input.files = dt.files;
    }

    isValidFile(file) {
        return file.size <= this.maxFileSize;
    }

}();